if (document.querySelector('.g-recaptcha')) {
    document.write(`<script src="https://www.google.com/recaptcha/api.js" async defer></script>`);
}
